import { Component, OnInit } from "@angular/core";
import { RegistrationService } from "src/app/registration/registration.service";
import { SharedService } from "../shared.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-terms-condition",
  templateUrl: "./terms-condition.component.html",
  styleUrls: ["./terms-condition.component.scss"],
})
export class TermsConditionComponent implements OnInit {
  term: any;
  constructor(
    private doctorService: RegistrationService,
    private sharedService: SharedService,
  ) {
    this.getTermConditions();
  }

  ngOnInit() {}

  getTermConditions() {
    this.doctorService.getTermsCondition().subscribe(
      (res: any) => {
        this.term = res.data[0];
      },
      (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    );
  }
  handleError(error) {
    this.sharedService.handleError(error);
  }
}
